import { render, staticRenderFns } from "./LockScreen.vue?vue&type=template&id=f712d302&scoped=true"
import script from "./LockScreen.vue?vue&type=script&lang=js"
export * from "./LockScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f712d302",
  null
  
)

export default component.exports